// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DOMUtils$Showside from "../utils/DOMUtils.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as Namespace$Showside from "../types/Namespace.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EdgeSwipeDetector$Showside from "../utils/EdgeSwipeDetector.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
var getTouchY = function getTouchY(e) {
  return e.touches ? e.touches[0].pageY : 0;
};
var getTouchX = function getTouchY(e) {
  return e.touches ? e.touches[0].clientX : 0;
};
var context = React.createContext({
  needsShadow: true,
  setNeedsShadow: function (value) {}
});
var provider = context.Provider;
function Drawer$Context$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
    value: value,
    children: children
  });
}
Drawer$Context$Provider.displayName = "Drawer.Context.Provider";
var Provider = {
  provider: provider,
  make: Drawer$Context$Provider
};
function use(param) {
  return React.useContext(context);
}
var Context = {
  context: context,
  Provider: Provider,
  use: use
};
function Drawer(Props) {
  var children = Props.children;
  var isOpenOpt = Props.isOpen;
  var scrollRef = Props.scrollRef;
  var scrollRef2 = Props.scrollRef2;
  var classNameOpt = Props.className;
  var onChangeState = Props.onChangeState;
  var onOpening = Props.onOpening;
  var onOpenOpt = Props.onOpen;
  var showOpt = Props.show;
  var showDragIndicatorOpt = Props.showDragIndicator;
  var fwdRef = Props.fwdRef;
  var onScrollLockOpt = Props.onScrollLock;
  var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var onOpen = onOpenOpt !== undefined ? onOpenOpt : function (param) {};
  var show = showOpt !== undefined ? showOpt : true;
  var showDragIndicator = showDragIndicatorOpt !== undefined ? showDragIndicatorOpt : true;
  var onScrollLock = onScrollLockOpt !== undefined ? onScrollLockOpt : function (param) {};
  var match = ListPageLayoutController$Showside.Context.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var trackEvent = match$1.trackEvent;
  var match$2 = ViewportContext$Showside.use(undefined);
  var windowHeight = match$2.windowSize.height;
  var isMobile = match$2.isMobile;
  var topMargin = StickyHeaderOffsetProvider$Showside.useLenient(undefined);
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var didEdgeSwipe = EdgeSwipeDetector$Showside.useEdgeSwipeDetectorImmediate(undefined);
  var onOpening$1 = Belt_Option.getWithDefault(onOpening, match$1.onDrawerOpening);
  var match$4 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$4.config.settings;
  var mobileDrawerHandleHeight = isMobile ? 14 : 0;
  var collapsedHeight = match.state.primaryNavbarHeight + mobileDrawerHandleHeight | 0;
  var match$5 = React.useState(function () {});
  var setDrag = match$5[1];
  var drag = match$5[0];
  var match$6 = React.useState(function () {
    return true;
  });
  var setNeedsShadow = match$6[1];
  var needsShadow = match$6[0];
  var setNeedsShadow$1 = function (value) {
    Curry._1(setNeedsShadow, function (param) {
      return value;
    });
  };
  var checkWillBeOpen = function (y, dy) {
    if (Pervasives.abs(dy) < 20) {
      return isOpen;
    } else {
      return dy < 0;
    }
  };
  var openToY = function (isOpen) {
    if (isOpen) {
      return topMargin;
    } else {
      return windowHeight - collapsedHeight | 0;
    }
  };
  var isScrollAtZero = function (ref) {
    return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(ref.current), function (el) {
      var scrollTop = el.scrollTop | 0;
      return scrollTop === 0;
    }), false);
  };
  var match$7 = settings.newMobilePDP;
  var isMobilePDP;
  if (isMobile && match$7) {
    var tmp = match$3.route;
    isMobilePDP = typeof tmp === "number" || tmp.TAG !== /* PDP */2 ? false : true;
  } else {
    isMobilePDP = false;
  }
  var isDragAllowed = function (touchTarget) {
    var touchTargetIsScrollRef1 = Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(scrollRef.current), function (el) {
      if (Caml_obj.equal(el, touchTarget)) {
        return true;
      } else {
        return DOMUtils$Showside.isDescendent(el, touchTarget);
      }
    }), false);
    var touchTargetIsScrollRef2 = Belt_Option.getWithDefault(Belt_Option.map(scrollRef2, function (ref) {
      return Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(ref.current), function (el) {
        if (Caml_obj.equal(el, touchTarget)) {
          return true;
        } else {
          return DOMUtils$Showside.isDescendent(el, touchTarget);
        }
      }), false);
    }), false);
    if (isMobilePDP) {
      return false;
    } else if (touchTargetIsScrollRef1) {
      if (isScrollAtZero(scrollRef) || !isOpen) {
        return !didEdgeSwipe;
      } else {
        return false;
      }
    } else if (touchTargetIsScrollRef2) {
      if (scrollRef2 !== undefined) {
        if (isScrollAtZero(scrollRef2) || !isOpen) {
          return !didEdgeSwipe;
        } else {
          return false;
        }
      } else {
        return !didEdgeSwipe;
      }
    } else {
      return !didEdgeSwipe;
    }
  };
  var lastTouchMoveY = React.useRef(0);
  var lastTouchMoveX = React.useRef(0);
  var isDragAllowedByAngleRef = React.useRef(undefined);
  var onTouchStart = function (e) {
    var pageX = getTouchX(e);
    var pageY = getTouchY(e);
    lastTouchMoveX.current = pageX;
    lastTouchMoveY.current = pageY;
    if (!isOpen) {
      return Curry._1(onScrollLock, true);
    }
  };
  var isDragAllowedByAngle = function (e) {
    var pageX = getTouchX(e);
    var pageY = getTouchY(e);
    var diffX = pageX - lastTouchMoveX.current | 0;
    var diffY = pageY - lastTouchMoveY.current | 0;
    var isSignificantMovement = (Math.imul(diffX, diffX) + Math.imul(diffY, diffY) | 0) >= 25;
    var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180.0 / Math.PI;
    var isGreaterThan45 = touchAngle > 45.0;
    var isDragAllowed = isSignificantMovement && isGreaterThan45;
    var match = isDragAllowedByAngleRef.current;
    if (match !== undefined) {} else {
      isDragAllowedByAngleRef.current = isDragAllowed;
    }
    return Belt_Option.getWithDefault(isDragAllowedByAngleRef.current, isDragAllowed);
  };
  var onTouchMove = function (e) {
    var target = e.target;
    var drawerStartY = openToY(isOpen);
    var isDragAllowed$1 = isDragAllowedByAngle(e) && isDragAllowed(target);
    if (!isDragAllowed$1) {
      return;
    }
    var nextFingerY = getTouchY(e);
    if (drag !== undefined) {
      var movement = drag.fingerStartY - nextFingerY | 0;
      return Curry._1(setDrag, function (param) {
        return {
          drawerStartY: drag.drawerStartY,
          drawerCurrentY: drag.drawerStartY - movement | 0,
          fingerStartY: drag.fingerStartY,
          fingerCurrentY: nextFingerY
        };
      });
    }
    Curry._1(setDrag, function (param) {
      return {
        drawerStartY: drawerStartY,
        drawerCurrentY: drawerStartY,
        fingerStartY: nextFingerY,
        fingerCurrentY: nextFingerY
      };
    });
    if (!isOpen) {
      Curry.app(trackEvent, ["swipe up drawer", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      return Curry._1(onOpening$1, undefined);
    }
  };
  var onTouchEnd = function (e) {
    isDragAllowedByAngleRef.current = undefined;
    if (!isOpen) {
      Curry._1(onScrollLock, false);
    }
    if (drag === undefined) {
      return;
    }
    var movement = drag.fingerCurrentY - drag.fingerStartY | 0;
    var nextState = checkWillBeOpen(drag.drawerCurrentY, movement);
    if (isOpen !== nextState) {
      Curry._1(onChangeState, nextState);
      if (isOpen) {
        if (nextState) {} else {
          Curry.app(trackEvent, ["swipe down drawer", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        }
      } else if (nextState) {
        Curry._1(onOpen, undefined);
      }
    } else {
      Curry._1(onChangeState, isOpen);
    }
    Curry._1(setDrag, function (param) {});
  };
  var fixedPositionCn = CSS$Showside.prefix(drag !== undefined || isOpen ? "top-0" : "bottom-0");
  var dragLimit = function (y) {
    return Caml.int_min(topMargin > y ? topMargin : y, windowHeight - collapsedHeight | 0);
  };
  var translateY = drag !== undefined ? dragLimit(drag.drawerCurrentY) : isOpen ? topMargin : (windowHeight - topMargin | 0) - collapsedHeight | 0;
  var style = {
    height: CSS$Showside.intToPx(windowHeight - topMargin | 0),
    zIndex: settings.zIndex,
    transform: CSS$Showside.translate3d(0, show ? translateY : windowHeight + collapsedHeight | 0, 0)
  };
  var previousCollapsedHeight = Previous$Showside.use(collapsedHeight, collapsedHeight);
  var previousWindowHeight = Previous$Showside.use(windowHeight, windowHeight);
  var transitionCn = drag === undefined && (previousCollapsedHeight === collapsedHeight || collapsedHeight === 0) && previousWindowHeight === windowHeight && !didEdgeSwipe ? CSS$Showside.prefix("transition duration-200 ease-out") : "";
  var stylingCn = CSS$Showside.prefix(isOpen || Belt_Option.isSome(drag) ? "bg-main text-primary" : "bg-drawer-main text-drawer-label");
  var shadowCn = needsShadow ? "shadow-xl" : "";
  var roundedCn = !needsShadow || isMobilePDP ? "" : "rounded-t-xl rounded-b-none";
  var match$8 = LocationConfig$Showside.use(undefined);
  var isAltFunnel = Caml_obj.equal(Belt_Option.map(match$8.namespace, Namespace$Showside.toString), "alt");
  return React.createElement(Drawer$Context$Provider, {
    value: {
      needsShadow: needsShadow,
      setNeedsShadow: setNeedsShadow$1
    },
    children: null
  }, React.createElement("div", {
    className: Cn.make([CSS$Showside.prefix("fixed w-full left-0 bottom-0 bg-main"), CSS$Showside.prefix("transform"), show ? CSS$Showside.prefix("translate-y-0") : CSS$Showside.prefix("translate-y-full"), transitionCn]),
    style: {
      height: CSS$Showside.intToPx(collapsedHeight - 26 | 0),
      zIndex: settings.zIndex
    }
  }), React.createElement(DataAttribute$Showside.make, {
    dataTestId: "smartnav-drawer",
    children: React.createElement("div", {
      ref: fwdRef,
      className: Cn.make([CSS$Showside.prefix("fixed left-0 w-full flex flex-col select-none touch-none overflow-hidden clip-path-bottom-xl"), CSS$Showside.prefix(shadowCn), CSS$Showside.prefix(roundedCn), fixedPositionCn, transitionCn, stylingCn, className]),
      style: style,
      onTouchEnd: onTouchEnd,
      onTouchMove: onTouchMove,
      onTouchStart: onTouchStart
    }, showDragIndicator && !isMobilePDP ? React.createElement("div", {
      className: CSS$Showside.prefix("w-full flex justify-center p-1.5 h-5 relative z-10")
    }, isAltFunnel ? null : React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["rounded-full w-12 h-1 opacity-25", isOpen || Belt_Option.isSome(drag) ? "bg-primary" : "bg-drawer-label"]))
    })) : null, React.createElement("div", {
      className: CSS$Showside.prefix("relative flex-grow")
    }, children))
  }));
}
Drawer.displayName = "Drawer";
var make = React.memo(Drawer);
export { getTouchY, getTouchX, Context, make };
/* context Not a pure module */